import { z } from 'zod';

import { createOffsetPaginationRequestQuerySchema } from './pagination';
import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const ExtractedEventDateSchema = z.object({
  extractedEventDateId: PrimaryKeySchema,
  extractedEventId: PrimaryKeySchema,
  parsedDate: z.coerce.date(),
});

export type ExtractedEventDate = z.infer<typeof ExtractedEventDateSchema>;

export const ExtractedEventDatesSchema = z.array(ExtractedEventDateSchema);

export type ExtractedEventDates = z.infer<typeof ExtractedEventDatesSchema>;

export const ExtractedEventDatesQuerySchema = z
  .object({
    extractedEventDateIds: commaDelimitedList(
      PrimaryKeySchema.array(),
    ).optional(),
    extractedEventIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
  })
  .merge(createOffsetPaginationRequestQuerySchema(z.enum(['parsedDate'])));

export type ExtractedEventDatesQuery = z.infer<
  typeof ExtractedEventDatesQuerySchema
>;

export const CreateExtractedEventDateSchema = z.object({
  extractedEventId: PrimaryKeySchema,
  parsedDate: z.coerce.date(),
});

export type CreateExtractedEventDate = z.infer<
  typeof CreateExtractedEventDateSchema
>;
